import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SLA_BANDS } from '../sla-rules';

/** The "Key" legend from the Exec Dashboard sheet. */
@Component({
  selector: 'app-legend-key',
  host: { class: 'legend-key' },
  template: `
    <span class="key-title">Key</span>
    @for (b of bands; track b.band) {
      <span class="pct-chip" [class]="'band-' + b.band">
        <span class="dot" aria-hidden="true"></span>{{ b.label }}
      </span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendKey {
  protected readonly bands = SLA_BANDS;
}
